"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class PubSub {
  constructor() {
    this.topics = {};
  }
  subscribe(topic, listener) {
    if (!this.topics[topic]) {
      this.topics[topic] = {
        queue: []
      };
    }
    const index = this.topics[topic].queue.push(listener) - 1;
    return {
      unsubscribe() {
        delete this.topics[topic].queue[index];
      }
    };
  }
  publish(topic, info) {
    if (!this.topics[topic] || !this.topics[topic].queue.length) return;
    const items = this.topics[topic].queue;
    items.forEach(item => {
      item(info);
    });
  }
}
var _default = exports.default = new PubSub();